const styles = {
  container: {
    backgroundColor: '#f7f8f9 !important',
    borderRadius: '.25rem !important',
    border: 'none !important',
    boxShadow: 'none !important',
    justifyContent: 'space-between !important',
    padding: '0 !important',
    width: '100% !important',
    height: '8.48125rem !important',
    display: 'flex !important',
  },
  tabItem: {
    flex: '1 1 0px !important',
    border: '0.0625rem solid #5b5b5b1f',
    borderRadius: '0.375rem !important',
    marginBottom: '0.0625rem !important',
    padding: '.74rem !important',
    '&:before': {
      backgroundColor: 'transparent !important',
    },
    '&.locked': {
      borderRadius: '.375rem .375rem 0 0 !important',
    },
  },
  merchantStats: {
    width: '60% !important',
    margin: '0 !important',
    padding: '0  !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'right !important',
  },
  active: {
    backgroundColor: '#fff !important',
    borderBottom: '0 !important',
    marginBottom: '0 !important',

    '&.locked': {
      border: '0.0625rem solid #5b5b5b1f',
      borderRadius: '0.375rem 0.375rem 0 0 !important',
    },
  },
  header: {
    '&&': {
      marginBottom: '1.875rem',
      color: '#646464',
    },
  },
};

export default styles;
